import React, { useEffect, useState } from "react";
import { API } from "../../Redux/actions/API";
import { useNavigate } from "react-router-dom";
import Table from "../Table/Table";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import { toast } from "react-toastify";

export default function UsdtBonusDetails() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [imglink, setimglink] = useState("");
  const [upiid, setupiid] = useState("");
  const [Type, setType] = useState("");
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);

  const referral_API = async () => {
    try {
      let responceRight = await API?.post(
        "/adminBankDetailsByBankidAdmin",
        {
          loginid: userId,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      //console.log("ewalletDetails", responceRight?.data?.data[0]);
      //   console.log("response", responceRight);
      responceRight = responceRight?.data?.data[0];
      setleftreferralApi([]);
      let arrayLeft = [];

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          Type:item?.type,
          imglink: <img src={`${item?.imglink}`} width={300} />,
          btcaddress: `${item?.btcaddress} `,
          edate: `${item?.edate}`,
        });
      });
      setleftreferralApi(arrayLeft);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const OnhandleSubmit_API = async () => {
    try {
      if(Type=='')
      {
        toast.error("Select Type")
        return;
      }
      else if(upiid=='')
        {
          toast.error("Select Address")
          return;
        }
       else if(imglink=='')
          {
            toast.error("Add Link")
            return;
          }
      let responceRight = await API?.post(
        `updateDepositDetails`,
        {
          loginid: userId,
          btcAddress: upiid,
          Type: Type,
          imglink: imglink,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("submit", responceRight?.data?.data);
      //console.log("response", responceRight?.data?.data[0][0]);
      //responceRight = responceRight?.data?.data[0][0];
      if (responceRight?.data?.data == "Success") {
        toast.success("Updated Successfully !!");
        referral_API();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error(responceRight?.data?.data);
      }
    } catch (e) {
      console.log("error directdeposite APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "" }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;

  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "Address", accessor: "btcaddress" },
      { Header: "Type", accessor: "Type" },
      { Header: "QR Code", accessor: "imglink" },
      { Header: "Date ", accessor: "edate" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div className="content-page">
        <div className="content">
          <div className="container">
            {/* <!-- Inline Form --> */}
            <div className="row">
              <div className="col-md-12">
                <div className="panel panel-primary">
                  <div className="panel-heading">
                    <h4 className="panel-title"> Update QR Details</h4>
                  </div>
                  <div
                    className="panel-body table-rep-plugin"
                    style={{ padding: "8px", overflowY: "scroll" }}>
                    <div className="col-md-12">
                      <>
                        {" "}
                        <div className="row mb-5">
                          <form>
                            <div className="col-sm-3">
                              <input
                                className="form-control in-ip-1"
                                id="upiid"
                                onChange={(e) => setupiid(e.target.value)}
                                name="upiid"
                                placeholder="Enter Address"
                                type="text"
                                value={upiid}
                                maxLength={100}
                              />
                            </div>
                            <div className="col-sm-3">
                              <select   className="form-control in-ip-1" 
                              onChange={(e)=>setType(e.target.value)}>
                              <option value="">Select Address Type </option>
                                <option value="USDT(BEP-20)">USDT (BEP-20) </option>
                                {/* <option value="USDT(TRC-20)">USDT (TRC-20) </option> */}
                              </select>
                            </div>
                            <div className="col-sm-4">
                              <input
                                className="form-control in-ip-1"
                                id="imglink"
                                onChange={(e) => setimglink(e.target.value)}
                                name="imglink"
                                placeholder="Enter Image Link"
                                type="text"
                                value={imglink}
                              />
                                <div className="col-sm-1">
                                <a className="btn btn-sm btn-primary" href="https://tools.atatus.net/tools/image-to-url" target="_blank">
                                  Go to Convert Image to Link
                                </a>                            </div>
                            </div>
                            

                            <div className="col-sm-1">
                              <input
                                type="button"
                                id="btnsearch"
                                onClick={() => OnhandleSubmit_API()}
                                className="btn btn-sm btn-primary"
                                value="Update"
                              />
                            </div>
                          </form>
                        </div>
                      </>
                      <div className="row panel panel-primary">
                        <div className="panel-heading">
                          <h4 className="panel-title"> USDT QR Details</h4>
                        </div>
                        <div
                          className="table-responsive"
                          data-pattern="priority-columns"
                          style={{ maxHeight: "500px", overflow: "scroll" }}>
                          <Table
                            data={currentPostleft}
                            columns={my_team.cols}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
